import { Directive, ElementRef, Input, OnInit } from '@angular/core';
import { LanguageSettings } from '../providers/languageSettings.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SnackMessageComponent } from '../pages/SnackMessageComponent/copy.snack.component';

@Directive({
  // tslint:disable-next-line:directive-selector
  selector: '[copy]'
})
export class CopytoclipDirective implements OnInit {

  copyButton: HTMLButtonElement;

  constructor(
    el: ElementRef,
    private languageSettings: LanguageSettings,
    public snackBar: MatSnackBar) {
      this.copyButton = el.nativeElement;
    }

    @Input('copy') code: string;
    @Input() parent: object;

    openSnackBar() {
      this.snackBar.openFromComponent(SnackMessageComponent, {
        duration: 500,
      });
    }

    ngOnInit() {
      const self = this;
      this.copyButton.addEventListener('click', () => {
        const textArea = document.createElement('textarea');
        textArea.value = self.parent[self.languageSettings.getSelectedLanguage() + self.code];
        console.log(textArea.value);
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        try {
            const successful = document.execCommand('copy');
            const msg = successful ? 'successful' : 'unsuccessful';
            console.log('Copying text command was ' + msg);
            this.openSnackBar();
        } catch (err) {
            console.error('Oops, unable to copy', err);
        }
        document.body.removeChild(textArea);
      }
    );
  }
}
